import ButtonLink from './buttonlink';

/**
 * @deprecated use BX.UI.Button
 */
export default class PopupWindowButtonLink extends ButtonLink
{

}